import { Button, Col, Form, message, Modal, Row } from 'antd'
import React, { useEffect } from 'react'
import iconCuponesAutoservicio from '../../assets/icon-cupon-redimible.svg'
import { setearMiles, validarLongitudMax } from 'util/funciones'
import { formatearFecha, formatosFecha } from 'util/formatDate'
import "./index.css"
import InputPrefix from 'components/InputPrefix/InputPrefix'
import { PutGenerarCupon } from '../../service/cupones-autoservicio.service'
import Storage from "util/store/Storage";

interface IProps {
     open: boolean
     onCancel: (isChange?: boolean) => void
     method: "CREATE" | "EDIT" | "VIEW"
     data: any
}

const FIELDS_NAME = {
     CUPON_ID: ['cupon_id'],
     CUPON_ADMINISTRATIVO: ['cupon_administrativo'],
     USUARIO_RESPONSABLE_ID: ['usuario_responsable_id'],
}

const ModalCupon = ({ open, onCancel, method, data }: IProps) => {
     const { usuario } = Storage.getState()
     const [form] = Form.useForm()
     const requiredRules = [{ required: true, message: "Campo requerido" }]
     const [dataCuponConfirmado, setDataCuponConfirmado] = React.useState({
          nuevo_cupon: "",
          fecha_vigencia: ""
     })

     const [stepsModal, setStepsModal] = React.useState<number>(0)
     const [loading, setLoading] = React.useState(false)

     const TITLE_MODAL = method === "EDIT" ? (stepsModal == 0 ? "Convertir a cupón redimible" : 'Cupón generado') : (method === "VIEW" ? "Cupón generado" : "Crear cupón")
     const INPUT_PREFIX = method === "EDIT" ? "Ingrese cupón administrativo*" : "Cupón convertido*"

     const CONTENT_TITLE = (
          <>
               {
                    (stepsModal === 0 || stepsModal === 1) ? (
                         <center>
                              <img src={iconCuponesAutoservicio} alt="icono" className='icon-table' width={40} />
                              <span className='title-modal-custom'>{TITLE_MODAL}</span>
                         </center>
                    ) : null
               }
          </>
     )

     const handleOnFinish = async () => {
          setLoading(true)
          try {
               await form.validateFields()

               const params = {
                    cupon_id: form.getFieldValue(FIELDS_NAME.CUPON_ID[0]),
                    cupon_administrativo: form.getFieldValue(FIELDS_NAME.CUPON_ADMINISTRATIVO[0]),
                    usuario_responsable_id: form.getFieldValue(FIELDS_NAME.USUARIO_RESPONSABLE_ID[0]),
               }

               const { data } = await PutGenerarCupon(params)
               setDataCuponConfirmado(data.body)
               setStepsModal(1)
          } catch (error: any) {
               console.log("ERROR NO SE HA PODIDO GENERAR EL CUPÓN: ", error)
               message.error(error?.response?.data?.message || "Error al generar el cupón")
          } finally {
               setLoading(false)
          }
     }

     const closeModal = () => {
          const isChange = stepsModal > 0
          onCancel(isChange)
          setStepsModal(0)
          form.resetFields()
          setDataCuponConfirmado({
               nuevo_cupon: "",
               fecha_vigencia: ""
          })
     }

     const changeStep = (step: number) => setStepsModal(step)

     useEffect(() => {
          if (open && method === "VIEW") {
               form.setFieldValue(FIELDS_NAME.CUPON_ADMINISTRATIVO[0], data?.cupon)
          }
          form.setFieldsValue({
               [FIELDS_NAME.CUPON_ID[0]]: data?.id_cupon,
               [FIELDS_NAME.USUARIO_RESPONSABLE_ID[0]]: usuario?.p_id,
          })
     }, [open])

     return (
          <Modal
               open={open}
               onCancel={closeModal}
               title={CONTENT_TITLE}
               closeIcon={true}
               closable={true}
               width={(stepsModal === 0 || stepsModal === 1) ? 800 : 500}
               footer={null}
               centered
          >
               {
                    (stepsModal === 0 || stepsModal === 1) ?
                         (
                              <>
                                   <Row gutter={8} className='container__info__cupon'>
                                        <Col xs={24} sm={12} md={8} lg={6} className='section__info__cupon'>
                                             <p className='title__info__cupon'>Valor</p>
                                             <span>${setearMiles(data?.valor ?? 0)}</span>
                                        </Col>
                                        <Col xs={24} sm={12} md={8} lg={6} className='section__info__cupon'>
                                             <p className='title__info__cupon'>Motivo</p>
                                             <span>{data?.motivo ?? ''}</span>
                                        </Col>
                                        <Col xs={24} sm={12} md={8} lg={6} className='section__info__cupon'>
                                             <p className='title__info__cupon'>Fecha emisión</p>
                                             <span>{data?.fecha_generacion ?? ''}</span>
                                        </Col>
                                        <Col xs={24} sm={12} md={8} lg={6} className='section__info__cupon'>
                                             <p className='title__info__cupon'>Fecha vigencia</p>
                                             <span>{data?.fecha_vigencia ?? ''}</span>
                                        </Col>
                                   </Row>
                                   <Row style={{ width: '100%', marginTop: 10 }}>
                                        <Form form={form} onFinish={handleOnFinish} layout="vertical" style={{ width: "100%" }}>
                                             <InputPrefix
                                                  disabled={method === "VIEW" || (stepsModal !== 0)}
                                                  name='cupon_administrativo'
                                                  prefix={INPUT_PREFIX}
                                                  placeholder='Escriba su cupón'
                                                  className="select-gray"
                                                  value={form.getFieldValue(FIELDS_NAME.CUPON_ADMINISTRATIVO[0])}
                                                  onChange={(e) => form.setFieldValue(FIELDS_NAME.CUPON_ADMINISTRATIVO[0], e.target.value)}
                                                  rules={[
                                                       ...requiredRules,
                                                       {
                                                            validator: validarLongitudMax(200),
                                                       },
                                                  ]}
                                                  maxLength={200}
                                             />
                                             {method === "VIEW" && <span>Usuario responsable: {data?.origen}</span>}
                                             {dataCuponConfirmado.nuevo_cupon !== "" ?
                                                  <p>Se ha generado el cupón: {dataCuponConfirmado?.nuevo_cupon} con vigencia de {formatearFecha(dataCuponConfirmado?.fecha_vigencia, formatosFecha.fecha)}</p>
                                                  :
                                                  <></>
                                             }
                                             {
                                                  method === "EDIT" && (
                                                       <Row style={{ display: 'flex', justifyContent: 'end' }}>
                                                            <Button
                                                                 type="primary"
                                                                 className="btn-submit-generate"
                                                                 onClick={dataCuponConfirmado?.nuevo_cupon === "" ? handleOnFinish : () => changeStep(2)}
                                                                 loading={loading}
                                                            >
                                                                 {dataCuponConfirmado?.nuevo_cupon === "" ? "Generar" : "Listo"}
                                                            </Button>
                                                       </Row>
                                                  )
                                             }
                                        </Form>
                                   </Row>
                              </>
                         )
                         :
                         (
                              stepsModal === 2 ?
                                   (
                                        <ContentStepConfirmacion onClick={closeModal} />
                                   ) : null
                         )
               }

          </Modal >
     )
}

const ContentStepConfirmacion = ({ onClick }: { onClick: () => void }) => {
     return (
          <>
               <Row style={{ display: 'flex', justifyContent: 'center' }}>
                    <img src={iconCuponesAutoservicio} alt="icono" className='icon-table' width={90} />
               </Row>
               <h6 style={{ textAlign: 'center' }}>
                    El cupón administrativo ha sido convertido exitosamente. Nuevo cupón redimible disponible para uso.
               </h6>
               <Row style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button type="primary" className="btn-submit-generate" onClick={onClick}>Listo</Button>
               </Row>
          </>
     )
}

export default ModalCupon